module.exports = __webpack_public_path__ + "static/banner-liquidites-desktop-95e0ae8d039d9d3b29d5d5b4fe5611a5.jpg";